import { Cancel, CheckCircle } from '@mui/icons-material';
import { Box, Card, CardContent, Divider, Typography } from '@mui/material';
import { get } from 'lodash';
import React, { FC } from 'react';

import MUIDownloadFile from '../../../../../../components/ui-component/form-component/form-fields/fields/MUIDownloadFile';
import { useApplication } from '../../../../../../context/ApplicationContext';
import { getUserJwt } from '../../../../../../context/AuthHelper';
import { PLATZHALTER_TEXT } from '../../../../../../lib/constants/constant';
import { STRAPI_URL } from '../../../../../../lib/constants/url';
import ApplicationHeading from '../../../application-heading/ApplicationHeading';

import antragschema from '../../../../../../lib/paths/antrag_FULL_Paths.json';
const P = antragschema.attributes;
const Bescheid: FC<{}> = () => {
	const { application } = useApplication();

	const status = get(application, `${P.Status.path}`, '');
	const file = get(application, `${P.Bescheid_Bescheid.path}`, '');

	const isPositive = status === 'bewilligt' && !!file?.id;
	const isNegative = status === 'abgelehnt' && !!file?.id;

	if (!file?.attributes?.url || (!isPositive && !isNegative)) return null;

	const handleDownloadBescheid = async () => {
		const url = file.attributes.url;
		const name = file.attributes.name;
		await fetchFile(url, name);
	};

	return (
		<>
			<ApplicationHeading title={isPositive ? 'Zusagebescheid' : 'Ablehnungsbescheid'} description={PLATZHALTER_TEXT} />

			<Card
				sx={{
					borderLeft: `6px solid ${isPositive ? '#4caf50' : '#f44336'}`,
					backgroundColor: isPositive ? '#e8f5e9' : '#ffebee',
					mt: 3,
				}}
			>
				<CardContent>
					<Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
						{isPositive ?
							<CheckCircle sx={{ color: '#4caf50', mr: 1 }} />
						:	<Cancel sx={{ color: '#f44336', mr: 1 }} />}
						<Typography variant='h6' component={'h2'} color={isPositive ? '#2e7d32' : '#c62828'}>
							{isPositive ?
								'Herzlichen Glückwunsch! Ihr Antrag wurde bewilligt.'
							:	'Wir bedauern, Ihnen mitteilen zu müssen, dass Ihr Antrag abgelehnt wurde.'}
						</Typography>
					</Box>
				</CardContent>
			</Card>
			<Divider sx={{ mb: 2 }} />

			<MUIDownloadFile fileMetaData={file} onDownload={handleDownloadBescheid} showDownloadButton={true} showDownloadedOn={false} downloadedOn={''} />
		</>
	);
};

export default Bescheid;

const fetchFile = async (url: string, fileName: string = '') => {
	try {
		const res = await fetch(`${STRAPI_URL}${url}`, {
			headers: {
				Authorization: `Bearer ${getUserJwt()}`,
			},
		});

		const blob = await res.blob();
		const objectUrl = URL.createObjectURL(blob);

		const link = document.createElement('a');
		link.href = objectUrl;
		link.download = fileName;
		document.body.appendChild(link);
		link.click();
		link.remove();
		URL.revokeObjectURL(objectUrl);
	} catch (err: any) {
		console.error(' ERROR: Downloading File ', err);
	}
};
